export const eventStatuses = {
  BUILDING: 'building',
  DRAFT: 'draft',
  LIVE: 'live',
  DELETED: 'deleted',
  PREVIEW: 'preview',
};
